<template>
  <div class="login-wrapper">
    <!-- Background Effects -->
    <div class="bg-base"></div>
    <div class="grid-lines"></div>
    <div class="orb orb-1"></div>
    <div class="orb orb-2"></div>
    <div class="orb orb-3"></div>

    <!-- Loader Overlay -->
    <transition name="fade">
      <div v-if="loading" class="loader-overlay">
        <div class="loader-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring inner"></div>
        </div>
        <p class="loader-text">Memverifikasi akun...</p>
      </div>
    </transition>

    <!-- Login Card -->
    <div class="login-container">
      <div class="card" :class="{ 'card-shake': shakeError }">

        <!-- Logo -->
        <div class="logo-area">
          <div class="logo-icon">P</div>
          <div class="logo-text">LaraPos</div>
        </div>

        <!-- Badge -->
        <div class="badge">
          <span class="badge-dot"></span>
          Sistem Kasir Online
        </div>

        <!-- Heading -->
        <h1>Selamat<br>Datang Kembali</h1>
        <p class="subtitle">Masuk ke akun Anda untuk melanjutkan</p>

        <!-- Error Message -->
        <transition name="slide-down">
          <div v-if="errorMsg" class="error-alert">
            <span class="error-icon">⚠️</span>
            {{ errorMsg }}
          </div>
        </transition>

        <!-- Form -->
        <form @submit.prevent="login">
          <div class="field" :class="{ 'field-focus': focusedField === 'email', 'field-filled': loginData.email }">
            <label>Username / Email</label>
            <div class="input-wrap">
              <span class="input-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </span>
              <input
                type="text"
                placeholder="Masukkan username atau email"
                autocomplete="username email"
                v-model="loginData.email"
                @focus="focusedField = 'email'"
                @blur="focusedField = ''"
              />
            </div>
          </div>

          <div class="field" :class="{ 'field-focus': focusedField === 'password', 'field-filled': loginData.password }">
            <label>Password</label>
            <div class="input-wrap">
              <span class="input-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </span>
              <input
                :type="showPassword ? 'text' : 'password'"
                placeholder="Masukkan password"
                autocomplete="current-password"
                v-model="loginData.password"
                @focus="focusedField = 'password'"
                @blur="focusedField = ''"
              />
              <button type="button" class="toggle-pass" @click="showPassword = !showPassword" tabindex="-1">
                <svg v-if="!showPassword" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
            </div>
          </div>

          <button type="submit" class="btn-login" :disabled="loading">
            <span class="btn-text">Masuk Sekarang</span>
            <span class="btn-arrow">→</span>
            <span class="btn-glow"></span>
          </button>
        </form>

        <div class="footer-text">
          © {{ new Date().getFullYear() }} LaraPos · Semua hak dilindungi
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "../../lib/httplib";

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      loginData: {},
      showPassword: false,
      focusedField: "",
      errorMsg: "",
      shakeError: false,
    };
  },
  methods: {
    login() {
      this.errorMsg = "";
      this.loading = true;

      HTTP.post("/api/auth/login", this.loginData)
        .then((res) => {
          console.log(res.data, "login-berhasil");
          this.$cookie.set("larapos", JSON.stringify(res.data.data));
          setTimeout(() => {
            window.location.href = "/";
            this.loading = false;
          }, 1000);
        })
        .catch((eres) => {
          this.loading = false;
          if (
            eres.response &&
            eres.response.data &&
            eres.response.data.error === "Unauthorized"
          ) {
            this.showError("Username dan password tidak cocok");
          } else if (
            eres &&
            eres.response &&
            eres.response.data &&
            eres.response.data.user_message
          ) {
            this.showError(eres.response.data.user_message);
          } else {
            this.showError("Server bermasalah. Silakan coba lagi.");
          }
        });
    },
    showError(msg) {
      this.errorMsg = msg;
      this.shakeError = true;
      setTimeout(() => (this.shakeError = false), 600);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=DM+Sans:wght@300;400;500&display=swap");

/* ─── Reset & Base ─── */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login-wrapper {
  font-family: "DM Sans", sans-serif;
  min-height: 100vh;
  background: #0a0a0f;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

/* ─── Background ─── */
.bg-base {
  position: fixed;
  inset: 0;
  z-index: 0;
  background: radial-gradient(
      ellipse 80% 60% at 20% 50%,
      rgba(99, 60, 180, 0.22) 0%,
      transparent 60%
    ),
    radial-gradient(
      ellipse 60% 80% at 80% 20%,
      rgba(20, 120, 200, 0.18) 0%,
      transparent 60%
    ),
    radial-gradient(
      ellipse 50% 50% at 60% 80%,
      rgba(180, 40, 100, 0.12) 0%,
      transparent 60%
    ),
    #0a0a0f;
}

.grid-lines {
  position: fixed;
  inset: 0;
  z-index: 0;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.025) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
  background-size: 60px 60px;
}

.orb {
  position: fixed;
  border-radius: 50%;
  filter: blur(80px);
  z-index: 0;
  animation: float 8s ease-in-out infinite;
}
.orb-1 {
  width: 500px;
  height: 500px;
  background: rgba(99, 60, 180, 0.14);
  top: -150px;
  left: -150px;
  animation-delay: 0s;
}
.orb-2 {
  width: 350px;
  height: 350px;
  background: rgba(20, 120, 200, 0.1);
  bottom: -100px;
  right: -100px;
  animation-delay: -3s;
}
.orb-3 {
  width: 250px;
  height: 250px;
  background: rgba(180, 40, 100, 0.08);
  top: 40%;
  right: 25%;
  animation-delay: -5s;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(20px, -30px) scale(1.06);
  }
}

/* ─── Container ─── */
.login-container {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
}

/* ─── Card ─── */
.card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(48px);
  -webkit-backdrop-filter: blur(48px);
  border-radius: 28px;
  padding: 52px 44px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.04), 0 40px 80px rgba(0, 0, 0, 0.55),
    0 0 120px rgba(99, 60, 180, 0.07);
  animation: cardIn 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.card-shake {
  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

@keyframes shake {
  10%,
  90% {
    transform: translateX(-3px);
  }
  20%,
  80% {
    transform: translateX(5px);
  }
  30%,
  50%,
  70% {
    transform: translateX(-5px);
  }
  40%,
  60% {
    transform: translateX(5px);
  }
}

/* ─── Logo ─── */
.logo-area {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}

.logo-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #6b3ccc, #2d7dd2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  color: white;
  font-family: "Playfair Display", serif;
  box-shadow: 0 8px 24px rgba(107, 60, 204, 0.45);
}

.logo-text {
  font-family: "Playfair Display", serif;
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #fff 30%, rgba(255, 255, 255, 0.45));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.3px;
}

/* ─── Badge ─── */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 12px;
  background: rgba(107, 60, 204, 0.1);
  border: 1px solid rgba(107, 60, 204, 0.2);
  border-radius: 20px;
  font-size: 11px;
  color: rgba(180, 150, 255, 0.85);
  margin-bottom: 20px;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #8b5cf6;
  animation: pulse 2.2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.75);
  }
}

/* ─── Heading ─── */
h1 {
  font-family: "Playfair Display", serif;
  font-size: 34px;
  font-weight: 700;
  color: #fff;
  line-height: 1.1;
  margin-bottom: 8px;
  letter-spacing: -0.6px;
}

.subtitle {
  color: rgba(255, 255, 255, 0.35);
  font-size: 14px;
  font-weight: 300;
  margin-bottom: 32px;
  letter-spacing: 0.1px;
}

/* ─── Error Alert ─── */
.error-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 10px;
  color: rgba(255, 160, 160, 0.9);
  font-size: 13px;
  margin-bottom: 20px;
}

.error-icon {
  font-size: 15px;
  flex-shrink: 0;
}

/* ─── Field ─── */
.field {
  margin-bottom: 16px;
}

.field label {
  display: block;
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.35);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: color 0.3s;
}

.field.field-focus label {
  color: rgba(139, 92, 246, 0.85);
}

.input-wrap {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  pointer-events: none;
  transition: color 0.3s;
}

.field.field-focus .input-icon {
  color: rgba(139, 92, 246, 0.7);
}

.field input {
  width: 100%;
  padding: 14px 42px 14px 42px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  color: #fff;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  outline: none;
  transition: all 0.3s;
  -webkit-appearance: none;
}

.field input::placeholder {
  color: rgba(255, 255, 255, 0.18);
}

.field input:focus {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(107, 60, 204, 0.55);
  box-shadow: 0 0 0 3px rgba(107, 60, 204, 0.1);
}

.toggle-pass {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  padding: 2px;
  transition: color 0.3s;
}
.toggle-pass:hover {
  color: rgba(255, 255, 255, 0.5);
}

/* ─── Button ─── */
.btn-login {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #6b3ccc 0%, #2d7dd2 100%);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-family: "DM Sans", sans-serif;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.3px;
  cursor: pointer;
  margin-top: 8px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
  box-shadow: 0 8px 24px rgba(107, 60, 204, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.btn-glow {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.12),
    transparent 60%
  );
  opacity: 0;
  transition: opacity 0.3s;
}

.btn-arrow {
  display: inline-block;
  transition: transform 0.3s;
}

.btn-login:hover .btn-arrow {
  transform: translateX(4px);
}

.btn-login:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 36px rgba(107, 60, 204, 0.5);
}

.btn-login:hover .btn-glow {
  opacity: 1;
}

.btn-login:active {
  transform: translateY(0);
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* ─── Footer ─── */
.footer-text {
  text-align: center;
  margin-top: 28px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.15);
  letter-spacing: 0.3px;
}

/* ─── Loader Overlay ─── */
.loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(10, 10, 15, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.loader-spinner {
  position: relative;
  width: 52px;
  height: 52px;
}

.spinner-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #8b5cf6;
  animation: spin 1s linear infinite;
}

.spinner-ring.inner {
  inset: 8px;
  border-top-color: #2d7dd2;
  animation-duration: 0.7s;
  animation-direction: reverse;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loader-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 0.5px;
}

/* ─── Transitions ─── */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
  max-height: 0;
}

/* ─── Responsive ─── */
@media (max-width: 480px) {
  .card {
    padding: 40px 28px;
    border-radius: 20px;
  }
  h1 {
    font-size: 28px;
  }
}
</style>